/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCreators, beforeUser } from './../user/user.action';
import { ENV } from './../../config/config';
import FullPageLoader from '../full-page-loader/full-page-loader'
const { userDefaultImg } = ENV

const Authors = (props) => {
    const [pagination, setPagination] = useState(null)
    const [creators, setCreators] = useState([])
    const [loader, setLoader] = useState(true)
    const [loadMoreBtn, setLoadMoreBtn] = useState(false)

    useEffect(() => {
        window.scroll(0, 0)
        // get creators
        getCreators()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // set creators & pagination
    useEffect(() => {
        if (props.user.creatorsAuth) {
            const creatorsData = props.user.creators
            if (creatorsData) {
                setCreators(creators.concat(creatorsData.creators))
                setPagination(creatorsData.pagination)
                props.beforeUser()
                setLoader(false)
            }
        }
    }, [props.user.creatorsAuth]) // eslint-disable-line react-hooks/exhaustive-deps

    // handle show load more button state when pagination is set
    useEffect(() => {
        if (pagination)
            setLoadMoreBtn((creators && pagination.total > 0 && pagination.total > creators.length && creators.length > 0))
    }, [pagination]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadMore = () => {
        const { page } = pagination
        setLoader(true)

        // get more creators
        getCreators(page + 1)
    }

    const getCreators = (page = 1, limit = 12) => {
        let creatorQS = { page, limit }
        const qs = ENV.objectToQueryString(creatorQS)
        props.getCreators(qs)
    }

    return (
        <section className="popular-collections-area creators-area ">
            {loader && <FullPageLoader />}
            <div className="custom-container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">
                        {/* Intro */}
                        <div className="intro text-center">
                            {/* <span>Creators</span> */}
                            <h3 className="mt-3 mb-0">Our Creators</h3>
                            {/* <p>Live auctions</p> */}
                        </div>
                    </div>
                </div>
                <div className=" d-flex align-items-center justify-content-start  flex-wrap custom-authors-card">
                    {
                        creators && creators.length ?
                            creators.map((author, key) => {
                                return (
                                    <div key={`author_${key}`} className=" item">
                                        <div className="card authors-card  text-center">
                                            <div className="image-over">
                                                <Link to={`/artist/${author.username}`}>
                                                    <img className="card-img-top" src={author.profileImage ? author.profileImage : userDefaultImg} alt="Author profile" />
                                                </Link>
                                                <div className="overlay">
                                                    <Link to={`/artist/${author.username}`}>
                                                        <h5>{author.username ? author.username : author.address} </h5>
                                                    </Link>
                                                    <div className="social-icons d-flex justify-content-center">
                                                    {
                                                        author.twitterLink && <a className="twitter" href={author.twitterLink} target="_blank" rel="noreferrer" data-toggle="tooltip" title="Twitter">
                                                            <i className="fab fa-twitter" />
                                                        </a>
                                                    }
                                                    {
                                                        author.personalPFLink && 
                                                        <a className="google-plus" href={author.personalPFLink} target="_blank" rel="noreferrer" data-toggle="tooltip" title="Personal Portfolio">
                                                            <i className="fas fa-google" />
                                                        </a>
                                                    }
                                                    {
                                                        author.brandedURLLink && <a className="vine" href={author.brandedURLLink} target="_blank" rel="noreferrer" data-toggle="tooltip" title="Brand Link">
                                                            <i className="fab fa-edge" />
                                                        </a>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )
                            })
                            :
                            <div className="no-data border"><p className="text-center">No Creators Found</p></div>
                    }
                </div>
                {
                    loadMoreBtn &&
                    <div className="row">
                        <div className="col-12 text-center">
                            <a id="load-btn" className="btn btn-danger offer  mt-5" onClick={() => loadMore()}>Load More</a>
                        </div>
                    </div>
                }
            </div>
        </section>
    );
}

const mapStateToProps = state => ({
    user: state.user
});

export default connect(mapStateToProps, { beforeUser, getCreators })(Authors);